/**
 * Persists the visitor's wholesale-approval status onto the cart as the
 * `wholesale_approved` attribute, so Switchboard's Cart Validation rule can
 * block checkout for non-approved visitors.
 *
 * The status is rendered server-side by snippets/wholesale-cart-flag.liquid
 * (approved = logged in AND 'Wholesale'-tagged). We only PATCH the cart when the
 * attribute is stale, to avoid a write on every page load.
 */
(function () {
  var island = document.getElementById('wholesale-cart-flag-data');
  if (!island) return;

  var desired;
  try {
    desired = JSON.parse(island.textContent).approved === true ? 'true' : 'false';
  } catch (e) {
    return;
  }

  var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var current = cart.attributes && cart.attributes.wholesale_approved;
      if (String(current) === desired) return;

      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ attributes: { wholesale_approved: desired } })
      });
    })
    .catch(function () { /* non-fatal: the Switchboard rule fails closed */ });
})();
